import { AnyType } from './common-types';

export function Metadata(metadata: AnyType) {
  return {
    getSize: () => metadata?.size,
    getHeight: () => metadata?.height,
    getWidth: () => metadata?.width,
    getDensity: () => metadata?.density,
    getDuration: () => metadata?.duration,
    getAspectRatio: () => metadata?.aspect_ratio,
    get heightString() {
      return metadata?.height ? metadata?.height + ' px' : undefined;
    },
    get widthString() {
      return metadata?.width ? metadata?.width + ' px' : undefined;
    },
    get iptc_photoGrapher() {
      return metadata?.xmp?.['dc:creator'] || metadata?.iptc?.['byline'];
    },
    get iptc_creator() {
      return metadata?.icc?.['creator'] || metadata?.xmp?.['dc:creator'];
    },
    get iptc_description() {
      return metadata?.xmp?.['dc:description'] || metadata?.iptc?.['caption'];
    },
    get codec_name() {
      return metadata?.['codec_long_name'] || metadata?.['codec_name'];
    },
    get fps() {
      return metadata?.['avg_frame_rate'] && metadata?.['avg_frame_rate'].split('/')[0];
    },
    get mbps() {
      return metadata?.['bit_rate'] && Math.round(metadata?.['bit_rate'] / 1000000);
    },
    get iptc_source() {
      return metadata?.xmp?.['dc:source'] || metadata?.xmp?.['photoshop:Source'] || metadata?.iptc?.['source'];
    },
    get iptc_copyRight() {
      return metadata?.xmp?.['dc:rights'] || metadata?.iptc?.['copyright'];
    },
    get dateCreated() {
      return metadata?.xmp?.['photoshop:DateCreated'] || (metadata?.iptc?.['dateCreated'] && dateFormatting(metadata?.iptc?.['dateCreated']));
    },
  };
}

function dateFormatting(date: string) {
  const dateString = date;
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);
  const newDate = new Date(year + '-' + month + '-' + day);
  return newDate.toISOString();
}
